import { render, staticRenderFns } from "./OilWaxCalculator.vue?vue&type=template&id=65fed365&scoped=true"
import script from "./OilWaxCalculator.vue?vue&type=script&lang=js"
export * from "./OilWaxCalculator.vue?vue&type=script&lang=js"
import style0 from "./OilWaxCalculator.vue?vue&type=style&index=0&id=65fed365&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fed365",
  null
  
)

export default component.exports